module.exports = __webpack_public_path__ + "img/anett-pisti.58a6bf86.jpg";